import { mutator } from 'satcheljs';
import getStore from '../store/store';
import selectEventDuration from '../../actions/selectEventDuration';
/**
 * Called when there is a change in the event duration dropdown
 */
export default mutator(selectEventDuration, function (actionMessage) {
    getStore().defaultMeetingDuration = actionMessage.defaultEventDuration;
});
//# sourceMappingURL=selectEventDuration.js.map